import { useLazyRef } from "utils/reactHooks";
import posthog from "posthog-js";
import React from "react";
import { useLocation } from "react-router";

import { Tracking } from "./tracking";

export type ServicesType = {
  tracking: Tracking;
};

export const ServicesCtx = React.createContext<ServicesType | null>(null);

export function Services({ children }: React.PropsWithChildren) {
  const location = useLocation();
  const tracking = useLazyRef(() => new Tracking());

  React.useEffect(() => {
    posthog.capture("$pageview");
  }, [location]);

  const value = React.useMemo(() => {
    return {
      tracking: tracking.current,
    };
  }, [tracking]);

  return <ServicesCtx.Provider value={value}>{children}</ServicesCtx.Provider>;
}
